// Utility function to get URL parameters
export const getUrlParams = () => {
    const params = new URLSearchParams(window.location.search);
    return Object.fromEntries(params.entries());
};

// Function to save gclid to session storage if present
export const saveGclid = () => {
    const params = getUrlParams();
    if (params.gclid) {
        sessionStorage.setItem('gclid', params.gclid);
    }
}; 